import { render, staticRenderFns } from "./childAdd.vue?vue&type=template&id=a31b4642&scoped=true&"
import script from "./childAdd.vue?vue&type=script&lang=js&"
export * from "./childAdd.vue?vue&type=script&lang=js&"
import style0 from "./childAdd.vue?vue&type=style&index=0&id=a31b4642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31b4642",
  null
  
)

export default component.exports